<template>
  <q-card flat>
    <q-card-section class="no-padding q-mt-xs" v-if="viewOnly">
      <q-banner class="bg-blue text-white" dense inline-actions>
        {{ titleSelectGoodDialog }}
      </q-banner>
    </q-card-section>
    <q-card-section class="no-padding text-center" v-if="!viewOnly">
      <q-btn round
             flat
             icon="add_circle"
             size="lg"
             padding="none"
             color="indigo"
             @click="showInsertProductDialog"
             v-if="$store.state.roles.some(v=>['admin','can _manage_goods_details'].includes(v))">
        <q-tooltip>
          افزودن کالای جدید
        </q-tooltip>
      </q-btn>
      <q-btn round
             icon="done_all"
             size="sm"
             color="indigo"
             @click="selectAllProducts">
        <q-tooltip>
          انتخاب همه محصول
        </q-tooltip>
      </q-btn>
      <q-btn round
             icon="settings"
             size="sm"
             class="q-ml-xs"
             color="indigo">
        <q-tooltip>
          تنظیمات
        </q-tooltip>
        <q-popup-proxy>
          <q-card flat>
            <q-card-section>
              <q-toggle
                  v-model="filter"
                  true-value="true"
                  false-value="false"
                  label="کالاهای موجود"
              />
              <q-toggle
                  v-model="filterBuyDayPrice"
                  true-value="true"
                  false-value="false"
                  label="کالاهایی که تاریخ خرید به روز ندارند"
              />
              <q-toggle
                  v-model="productWithDelayInSale"
                  true-value="true"
                  false-value="false"
                  label="کالاهایی با تاخیردر فروش"
              />
            </q-card-section>
          </q-card>
        </q-popup-proxy>
      </q-btn>
    </q-card-section>
    <q-card-section class="no-padding q-ml-md" v-if="!viewOnly">
      <q-icon size="sm" color="red-14" class="q-mt-xs" name="warning" round flat/>
      <span class="text-caption">موجودی بیشتر از ۱/۲ تعداد آخرین خرید می باشد</span>
    </q-card-section>
    <q-card-section class="no-padding" v-if="viewOnly || showGroups">
      <q-input v-if="isExistsLocalSearch" dense class="q-mb-xs" v-model="localSearchKey" filled label="جستجو ..."/>
      <div class="q-gutter-none">
        <q-chip color="red" text-color="white" icon="clear"
                v-if="productList && productList.length>0 && viewOnly" square size="sm" label="خالی نمودن لیست"
                @click="searchByGroupName(undefined)" clickable/>
        <q-space v-if="productList && productList.length>0"/>
      </div>
    </q-card-section>
    <q-card-section class="no-padding">
      <q-expansion-item header-class="bg-indigo text-white"
                        style="border-radius: 10px"
                        v-if="productList && productList.length>0"
                        expand-separator
                        v-model="expendedProductGroups"
                        label="لیست گروه محصولات نتیجه جستجو">
        <q-chip color="indigo" text-color="white" square size="sm" label="تمام گروه ها"
                v-if="productListOptions && productListOptions.length>0"
                @click="searchByGroupName('total')" clickable/>
        <q-chip size="sm" v-for="(item, index) in [...new Set(productListOptions.map(item => item.Group_Name))]"
                :key="index"
                clickable square
                :label="item" @click="searchByGroupName(item)">
        </q-chip>

      </q-expansion-item>
    </q-card-section>
    <q-card-section class="no-padding">
      <q-table
          flat
          :data="productList"
          :columns="columns"
          row-key="ID"
          :pagination="pagination"
          :filter="filter"
          wrap-cells
          hide-header
          :filter-method="showExistsProduct">
        <template v-slot:body="props">
          <q-tr :props="props" class="my-class">
            <q-td class="q-pa-xs" :class="$q.screen.lt.md?'no-padding':''">
              <q-card class="shadow-2 no-padding">
                <div class="row full-width">
                  <div class="col-xs-12 col-md-10">
                    <q-card-section class="no-padding">
                      <q-chip size="sm" color="indigo-10" text-color="white" :label="props.row.Group_Name"/>
                      <q-chip square color="red-14"
                              text-color="white"
                              icon="speed"
                              size="xs"
                              v-if="parseInt(props.row.OriginalBuyDayPrice) < parseInt(props.row.BuyLast_Price)"
                              label="قیمت خرید روز از خرید اصلی کمتر است"/>
                      <q-space/>
                      <q-chip color="indigo" text-color="white" square rounded :label="props.row.Goods_Code"/>
                      <span class="text-subtitle1 text-blue-10 text-bold">
                    {{ props.row.title }}
                  </span>
                      <q-btn flat round icon="account_tree" padding="none" color="brown"
                             v-if="props.row.GoodsDependencyChainsCount>0"
                             @click="showDependency(props.row, true)">
                        <q-tooltip>
                          نمایش کالاهای وابسته
                        </q-tooltip>
                      </q-btn>
                      <q-icon size="sm" v-if="props.row.MustBeSale" color="red-14" class="blink" name="warning"
                              round flat>
                        <q-tooltip>
                          موجودی بیشتر از ۱/۲ تعداد آخرین خرید می باشد
                        </q-tooltip>
                      </q-icon>

                    </q-card-section>
                    <q-card-section class="no-padding q-mt-xs">
                      <q-chip size="sm" square class="q-ml-xs">
                        <b>{{ props.row.Unit_Name }}</b>
                      </q-chip>
                      <q-chip size="sm" v-if="props.row.BuyLast_Date" color="red" text-color="white" square
                              class="q-ml-xs">
                        <span> آخرین خرید: </span> <b>{{ props.row.BuyLast_Date }}</b>
                      </q-chip>
                      <q-chip size="sm" square text-color="white" color="red" class="q-ml-xs"
                              v-if="props.row.BuyDay_Date">
                        تاریخ خرید روز
                        (<b>{{ props.row.BuyDay_Date }}</b>)
                      </q-chip>
                      <q-chip size="sm" square text-color="white" color="green-10" class="q-ml-xs"
                              v-if="props.row.GoEvent_Date">تاریخ آخرین انبارگردانی
                        (<b>{{ props.row.GoEvent_Date.toString().substring(0, 10) }}</b>)
                        <q-tooltip>
                          <span>تعداد شمارش</span>&nbsp;<span>({{ props.row.PhysicalCount }})</span>
                          <q-space/>
                          <span>انبار</span><span>({{ props.row.StorName }})</span>
                        </q-tooltip>
                      </q-chip>
                      <q-chip size="sm" square :color="props.row.TransactionCount>=4?'green-10':'deep-orange-10'"
                              text-color="white"
                              icon="speed"
                              :label="props.row.TransactionCount>=4?'تند فروش':'کند فروش'"/>
                    </q-card-section>
                    <q-card-section class="no-padding">

                      <q-chip v-if="props.row.ReserveGoodsInStore && IsJson(props.row.ReserveGoodsInStore)"
                              :clickable="props.row.ReserveGoodsInStore && IsJson(props.row.ReserveGoodsInStore)"
                              @click="showReserveList(props.row)"
                              :dense="$q.screen.lt.md" :size="$q.screen.lt.md?'md':'md'" square flat
                              label="رزرو سفارش">
                        <q-badge color="red-10" text-color="white" class="q-ml-xs">
                          {{ lodash.sumBy(JSON.parse(props.row.ReserveGoodsInStore), item => item.GoEvent_StOut) }}
                        </q-badge>
                      </q-chip>
                      <q-chip v-if="props.row.TranspostReserveStor && IsJson(props.row.TranspostReserveStor)"
                              :dense="$q.screen.lt.md" :size="$q.screen.lt.md?'md':'md'" square flat
                              label="رزرو انتقالی">
                        <q-badge color="red-10" text-color="white" class="q-ml-xs">
                          {{ lodash.sumBy(JSON.parse(props.row.TranspostReserveStor), item => item.GoEvent_StOut) }}
                        </q-badge>
                        <q-tooltip>
                          <div v-for="(item, index) in JSON.parse(props.row.TranspostReserveStor)" :key="index">
                            {{ item.StorName }} ({{ item.GoEvent_Num }}) : {{ item.GoEvent_StOut }}
                            <q-space/>
                          </div>
                        </q-tooltip>
                      </q-chip>
                    </q-card-section>
                    <q-card-section class="no-padding">
                      <q-chip :dense="$q.screen.lt.md" :size="$q.screen.lt.md?'md':'md'" square flat
                              label="کل">
                        <q-badge :color="props.row.Goods_Stock===0?'red-14':'purple'" class="q-ml-xs">
                          {{ props.row.Goods_Stock - props.row.GStor5 }}
                        </q-badge>
                      </q-chip>
                      <q-chip v-if="props.row.GStor1" :dense="$q.screen.lt.md" :size="$q.screen.lt.md?'md':'md'"
                              square flat
                              label="مرکزی">
                        <q-badge :color="props.row.GStor1<=0?'red-14':'purple'" class="q-ml-xs">
                          {{ props.row.GStor1 }}
                        </q-badge>
                      </q-chip>
                      <q-chip v-if="props.row.GStor2" :dense="$q.screen.lt.md" :size="$q.screen.lt.md?'md':'md'"
                              square flat
                              label="فروشگاه">
                        <q-badge :color="props.row.GStor2<=0?'red-14':'purple'" class="q-ml-xs">
                          {{ props.row.GStor2 }}
                        </q-badge>
                      </q-chip>
                      <q-chip v-if="props.row.GStor3" :dense="$q.screen.lt.md" :size="$q.screen.lt.md?'md':'md'"
                              square flat
                              label="پل پنجم">
                        <q-badge :color="props.row.GStor3<=0?'red-14':'purple'" class="q-ml-xs">
                          {{ props.row.GStor3 }}
                        </q-badge>
                      </q-chip>
                      <q-chip v-if="props.row.GStor4" :dense="$q.screen.lt.md" :size="$q.screen.lt.md?'md':'md'"
                              square flat
                              label="کارخانه صاف">
                        <q-badge :color="props.row.GStor4<=0?'red-14':'purple'" class="q-ml-xs">
                          {{ props.row.GStor4 }}
                        </q-badge>
                      </q-chip>
                      <q-chip v-if="props.row.GStor6" :dense="$q.screen.lt.md" :size="$q.screen.lt.md?'md':'md'"
                              square flat
                              label="دیجیکالا">
                        <q-badge :color="props.row.GStor6<=0?'red-14':'purple'" class="q-ml-xs">
                          {{ props.row.GStor6 }}
                        </q-badge>
                      </q-chip>
                    </q-card-section>
                    <q-card-section horizontal class="no-padding">
                      <div class="row full-width">
                        <div class="col-md-6 col-xs-12">
                          <q-card-section class="no-padding">
                            <q-card-section class="no-padding">
                              <q-chip square label="موجودی قابل سفارش"
                                      v-if="(props.row.Goods_Stock - props.row.GStor5 - props.row.GoEvent_StOut>0)
                                  && (props.row.Goods_Stock - props.row.GStor5 - props.row.GoEvent_StOut!==props.row.Goods_Stock)">
                                <q-badge class="q-ml-xs" color="green-10" text-color="white"
                                         :label="props.row.Goods_Stock - props.row.GStor5 -props.row.GoEvent_StOut"/>
                              </q-chip>
                            </q-card-section>
                            <q-card-section class="no-padding"
                                            v-if="props.row.ReserveGoodsInStore && props.row.ReserveGoodsInStore.length>0">
                              <div class="text-subtitle1">
                                رزرو به تفکیک انبار
                              </div>
                              <span v-for="(item, index) in JSON.parse(props.row.ReserveGoodsInStore)" :key="index">
                            <q-chip square :label="item.StorName">
                            <q-badge class="q-ml-xs" color="green-10" text-color="white"
                                     :label="item.GoEvent_StOut" v-if="item.StorID===1 "/>
                            <q-badge class="q-ml-xs" color="green-10" text-color="white"
                                     :label="item.GoEvent_StOut" v-if="item.StorID===2"/>
                            <q-badge class="q-ml-xs" color="green-10" text-color="white"
                                     :label="item.GoEvent_StOut" v-if="item.StorID===3"/>
                            <q-badge class="q-ml-xs" color="green-10" text-color="white"
                                     :label="item.GoEvent_StOut" v-if="item.StorID===4"/>
                          </q-chip>

                          </span>
                            </q-card-section>
                          </q-card-section>
                        </div>
                      </div>
                    </q-card-section>
                    <q-card-section
                        class="no-padding"
                        v-if="$store.state.roles.some(v=>['admin','can_see_product_price'].includes(v))">
                      <q-chip square label="نقد کارتن">
                        <q-badge color="deep-orange-10" class="q-ml-xs">
                          {{ props.row.SaleG_Price_Box | toLoalString }}
                        </q-badge>
                      </q-chip>
                      <q-chip square label="نقد بسته">
                        <q-badge color="deep-orange-10" class="q-ml-xs">
                          {{ props.row.SaleG_Price | toLoalString }}
                        </q-badge>
                      </q-chip>
                      <q-chip square label="لیست">
                        <q-badge color="deep-orange-10" class="q-ml-xs">
                          {{ props.row.List_Price | toLoalString }}
                        </q-badge>
                      </q-chip>
                      <q-chip square label="اتحادیه">
                        <q-badge color="deep-orange-10" class="q-ml-xs">
                          {{ props.row.Price | toLoalString }}
                        </q-badge>
                      </q-chip>
                    </q-card-section>
                    <q-card-actions>
                      <q-btn v-if="(isSelectionForm && props.row.Goods_SaleStatus===50101) || preBuyOrderRequest" round
                             icon="add"
                             :color="props.row.Goods_Stock===0?'red':'indigo'"
                             @click="selectGood(props.row)">
                        <q-tooltip>
                          انتخاب محصول
                        </q-tooltip>
                      </q-btn>
                      <q-btn class="q-mt-xs" round flat icon="lock" padding="none" size="lg" color="red"
                             v-if="props.row.Goods_SaleStatus!==50101"
                             :disable="!$store.state.roles.some(v=>['admin','can_change_product_state'].includes(v))"
                             @click="showGoodsStateDialog(props.row)"
                      >
                        <q-tooltip>
                          {{ props.row.General_Name }}
                        </q-tooltip>
                      </q-btn>
                      <q-btn round flat icon="edit" padding="none" size="lg"
                             color="indigo"
                             @click="showEditProductDialog(props.row)"
                             v-if="$store.state.roles.some(v=>['admin','can _manage_goods_details'].includes(v))">
                        <q-tooltip>
                          ویرایش محصول
                        </q-tooltip>
                      </q-btn>
                      <q-btn round
                             flat
                             icon="attach_money"
                             size="lg"
                             padding="none"
                             color="indigo"
                             @click="showChangePriceDialog(props.row)"
                             v-if="$store.state.roles.some(v=>['admin','can_change_goods_price'].includes(v))">
                        <q-tooltip>
                          قیمت گذاری کالا
                        </q-tooltip>
                      </q-btn>
                      <q-btn round flat icon="delete" padding="none" size="lg"
                             color="red"
                             v-if="$store.state.roles.some(v=>['admin','can _manage_goods_details'].includes(v))">
                        <q-tooltip>
                          حذف محصول
                        </q-tooltip>
                      </q-btn>
                      <q-btn round icon="info" padding="none" size="lg"
                             :color="props.row.Goods_Stock===0?'red-10':'indigo'"
                             @click="showProductDetailsDialog(props.row)">
                        <q-tooltip>
                          مشاهده جزییات
                        </q-tooltip>
                      </q-btn>
                      <q-btn round icon="privacy_tip" flat padding="none" size="lg"
                             :color="props.row.Goods_Stock===0?'red-10':'indigo'"
                             @click="showCatexDialog(props.row)">
                        <q-tooltip>
                          کارتکس کالا
                        </q-tooltip>
                      </q-btn>
                      <q-btn class="q-mt-xs" round flat icon="lock" padding="none" size="lg" color="red"
                             v-if="!isSelectionForm && props.row.Goods_SaleStatus!==50101"
                             :disable="!$store.state.roles.some(v=>['admin','can_change_product_state'].includes(v))"
                             @click="showGoodsStateDialog(props.row)"
                      >
                        <q-tooltip>
                          {{ props.row.General_Name }}
                        </q-tooltip>
                      </q-btn>
                      <q-btn class="q-mt-xs"
                             round flat icon="auto_fix_normal"
                             padding="none"
                             size="lg"
                             color="purple"
                             @click="showGoodsEditDialog(props.row)"
                             v-if="!isSelectionForm && $store.state.roles.some(v=>['admin','can_edit_goods_exists'].includes(v))">
                        <q-tooltip>
                          اصلاح موجودی کالا
                        </q-tooltip>
                      </q-btn>
                      <q-btn class="q-mt-xs"
                             round flat icon="warehouse"
                             padding="none"
                             size="lg"
                             color="indigo"
                             @click="showWarehouseHandling(props.row)"
                             v-if="!isSelectionForm && $store.state.roles.some(v=>['admin','can_warehouse-handling'].includes(v))">
                        <q-tooltip>
                          انبارگردانی
                        </q-tooltip>
                      </q-btn>
                      <q-btn class="q-mt-xs"
                             round flat icon="pan_tool"
                             padding="none"
                             size="lg"
                             color="blue-grey-14"
                             @click="showGoodsStateDialog(props.row)"
                             v-if="!isSelectionForm && props.row.Goods_SaleStatus===50101 && $store.state.roles.some(v=>['admin','can_change_product_state'].includes(v))">
                        <q-tooltip>
                          تغییر وضعیت فروش کالا
                        </q-tooltip>
                      </q-btn>
                      <q-btn class="q-mt-xs"
                             round flat icon="link"
                             padding="none"
                             size="lg"
                             color="brown"
                             @click="showDependency(props.row, false)"
                             v-if="props.row.Goods_SaleStatus===50101 && $store.state.roles.some(v=>['admin','can_set_goods_sale_chains'].includes(v))">
                        <q-tooltip>
                          تعیین وابستکی محصول
                        </q-tooltip>
                        <q-badge v-if="props.row.dependencies" floating color="red" text-color="white" rounded
                                 :label="JSON.parse(props.row.dependencies).length"/>
                      </q-btn>
                      <q-btn class="q-mt-xs"
                             v-if="$store.state.roles.some(v=>['admin','can_see_customer_list'].includes(v)) && !buyList"
                             round
                             flat
                             icon="person_off"
                             padding="none"
                             size="lg"
                             :color="'blue-grey-14'"
                             @click="showCustomerNoWorking(props.row)">
                        <q-tooltip>
                          لیست طرف معامله که کالا را خریداری ننموده اند
                        </q-tooltip>
                      </q-btn>
                      <q-btn class="q-mt-xs"
                             round
                             flat
                             icon="person"
                             padding="none"
                             size="lg"
                             :color="'blue-grey-14'"
                             v-if="$store.state.roles.some(v=>['admin','can_see_customer_list'].includes(v)) && !buyList"
                             @click="showCustomerWorking(props.row)">
                        <q-tooltip>
                          لیست طرف معامله که کالا را خریداری نموده اند
                        </q-tooltip>
                      </q-btn>
                      <q-btn class="q-mt-xs"
                             round
                             flat
                             icon="insights"
                             padding="none"
                             size="lg"
                             :color="'blue-grey-14'"
                             v-if="$store.state.roles.some(v=>['admin','can_see_by_price'].includes(v))"
                             @click="showPriceTrace(props.row)">
                        <q-tooltip>
                          تغییرات قیمتی
                        </q-tooltip>
                      </q-btn>
                      <q-btn class="q-mt-xs"
                             round
                             flat
                             icon="bar_chart"
                             padding="none"
                             size="lg"
                             :color="'blue-grey-14'"
                             v-if="$store.state.roles.some(v=>['admin','can_see_yearly_report'].includes(v))"
                             @click="showGoodsDashBoard(props.row)">
                        <q-tooltip>
                          داشبورد فروش کالا
                        </q-tooltip>
                      </q-btn>
                    </q-card-actions>
                  </div>
<!--                  <div class="col-md-2 items-center justify-center" v-if="!$q.screen.lt.md && !isSelectionForm">-->
<!--                    <qr-code-->
<!--                        error-level="L"-->
<!--                        :text="props.row.Goods_Code"/>-->
<!--                  </div>-->
                </div>

              </q-card>
            </q-td>
          </q-tr>
        </template>
      </q-table>
    </q-card-section>
    <q-dialog v-model="productPriceTrace" maximized full-width>
      <ProductPriceTraceList :product-info="selectedProduct"/>
    </q-dialog>
    <q-dialog
        :full-width="$q.screen.lt.md"
        v-model="showProductDetails">
      <ProductDetail :product="selectedProductDetails" @goodsPriceUpdated="goodsPriceUpdated"/>
    </q-dialog>
    <q-dialog maximized v-model="showCartex">
      <GoodsCartex :goods-info="selectedProductDetails"/>
    </q-dialog>
    <q-dialog :maximized="$q.screen.lt.md" v-model="goodsEditDialog">
      <GoodsStore :goods-info="selectedProduct"/>
    </q-dialog>
    <q-dialog :maximized="$q.screen.lt.md" v-model="warehouseDialog">
      <WarehouseHandling :goods-info="selectedProduct"/>
    </q-dialog>
    <q-dialog :maximized="$q.screen.lt.md" v-model="goodsStateDialog">
      <ChangeState :goods-info="selectedProduct" :group-info="null" @close-dialog="changedGoodsState"/>
    </q-dialog>
    <q-dialog maximized seamless v-model="goodsDependencyDialog">
      <ProductDependencyManage :is-select-form="isSelectionForm" :goods-info="this.selectedProduct"/>
    </q-dialog>
    <q-dialog v-model="showReserveDialog" :maximized="$q.screen.lt.md">
      <ReserveExiList :goods-info="selectedProduct"/>
    </q-dialog>
    <q-dialog maximized v-model="customerDialog">
      <CustomersList :items="customerList" :is-dialog="true"
                     :is-only-search-list="true"
                     :title="customerListDialogTitle"/>
    </q-dialog>
    <q-dialog v-model="insertProductDialog" :maximized="$q.screen.lt.md" persistent>
      <ProductCU action="insert" @close-dialog="insertProductDialog=false" :product-info="undefined" @product-inserted="productInserted"/>
    </q-dialog>
    <q-dialog v-model="editProductDialog" :maximized="$q.screen.lt.md" persistent>
      <ProductCU @product-updated="productUpdated" @close-dialog="editProductDialog=false" action="edit" :product-info="selectedProduct"/>
    </q-dialog>
    <q-dialog v-model="changeGoodsPriceDialog"
              :maximized="$q.screen.lt.md">
      <GoodsPrice @change-price="updatePrice"
                  :product-info="selectedProduct"/>
    </q-dialog>
    <q-dialog v-model="productGoodsDashboard" maximized full-width>
      <SaleYearlyDashboard :goods-info="selectedProduct" :is-dialog="true"/>
    </q-dialog>
    <q-dialog
        :maximized="$q.screen.lt.md"
        v-if="selectedProduct"
        v-model="addProductDialog">
      <q-card style="width: 400px; max-width: 80vw;">
        <q-card-section>
          <div class="text-bold">
            <q-btn round color="indigo" padding="none" text-color="white" icon="info"
                   @click="showProductDetails=true"/>
            {{ selectedProduct.Goods_Name }}
          </div>
          <q-badge class="bg-red-14"><i>موجودی(</i><b>{{ selectedProduct.Goods_Stock }}</b><i>)
            {{ selectedProduct.Unit_Name }}</i></q-badge>
        </q-card-section>
        <q-card-section v-if="selectedProduct.lastSaleInfo">
          <span class="text-subtitle2">آخرین خرید طرف معامله</span> <span> در تاریخ </span> <span
            class="text-red text-subtitle2"> {{ selectedProduct.lastSaleInfo.Sale_Date }}</span>
          <span> و به مبلغ واحد </span> <span
            class="text-red-10 text-subtitle2">
          {{ selectedProduct.lastSaleInfo.SaleG_PricePure.toLocaleString() }}</span>
          <span> و تعداد </span> <span class="text-red text-subtitle2"> {{
            selectedProduct.lastSaleInfo.SaleG_Count
          }} </span>
          <span> {{ selectedProduct.lastSaleInfo.Unit_Name }} </span>
          <span> می باشد</span>
        </q-card-section>
        <q-form autofocus greedy
                @submit="onDialogSubmit"
                @reset="onDialogReset"
                class="q-gutter-md q-gutter-sm">
          <q-card-section>
            <q-input
                :dense="$q.screen.lt.md"
                v-model="inputProductAmount"
                filled
                type="number"
                label="تعداد درخواستی"
                autofocus
                dir="ltr"
                :rules="[
                          val => val !== null && val !== '' || 'تعداد درخواستی را وارد نمایید',
                          val => val > 0  || 'تعداد درخواستی عددی بزرگتر از صفر می تواند باشد'
                        ]"
            />
            <q-separator/>
            <div class="items-center justify-center row q-mt-xs q-mt-sm q-mt-ma">
              <q-badge class="bg-purple-14 q-mr-xs q-pa-xs"><i>تعداد در بسته(</i><b>
                {{ selectedProduct.Goods_Pak }}</b><i>)
                {{ selectedProduct.Unit_Name }}</i></q-badge>
              <q-badge class="bg-indigo-14 q-ml-xs q-pa-xs"><i>تعداد در
                کارتن(</i><b>{{ selectedProduct.Goods_Box }}</b><i>)
                {{ selectedProduct.Unit_Name }}</i></q-badge>
            </div>
          </q-card-section>

          <q-card-section>
            <span class="text-subtitle1">موجودی به تفکیک انبار</span>
            <q-space/>
            <q-chip :size="$q.screen.lt.md?'md':'md'" square flat label="مرکزی">
              <q-badge color="deep-orange-10" class="q-ml-xs">{{ selectedProduct.GStor1 }}</q-badge>
            </q-chip>
            <q-space v-if="$q.screen.lt.md"/>
            <q-chip :size="$q.screen.lt.md?'md':'md'" square flat label="فروشگاه">
              <q-badge color="deep-orange-10" class="q-ml-xs">{{ selectedProduct.GStor2 }}</q-badge>
            </q-chip>
            <q-space v-if="$q.screen.lt.md"/>
            <q-chip :size="$q.screen.lt.md?'md':'md'" square flat label="پل پنجم">
              <q-badge color="blue" class="q-ml-xs">{{ selectedProduct.GStor3 }}</q-badge>
            </q-chip>
            <q-space v-if="$q.screen.lt.md"/>
            <q-chip :size="$q.screen.lt.md?'md':'md'" square flat label="کارخانه صاف">
              <q-badge color="pink" class="q-ml-xs">
                {{ selectedProduct.GStor4 }}
              </q-badge>
            </q-chip>
            <q-space v-if="$q.screen.lt.md"/>
            <q-chip :size="$q.screen.lt.md?'md':'md'" square flat label="دیجیکالا">
              <q-badge color="pink" class="q-ml-xs">
                {{ selectedProduct.GStor6 }}
              </q-badge>
            </q-chip>
          </q-card-section>

          <q-card-actions align="right">
            <q-btn label="تایید" type="submit" color="primary" icon="check" v-close-popup/>
            <q-btn flat label="انصراف" color="red" icon="cancel" v-close-popup/>
          </q-card-actions>
        </q-form>
      </q-card>
    </q-dialog>
  </q-card>
</template>

<script>
import EventBus from "@/event-bus";
import {mapActions} from 'vuex'
import GoodsCartex from "@/components/store/GoodsCartex";
import GoodsStore from "@/components/store/GoodsStore";
import ChangeState from "@/components/products/ChangeState";
import ProductDependencyManage from "@/components/productInfo/ProductDependencyManage";
import ReserveExiList from "@/components/products/ReserveExiList";
import WarehouseHandling from "@/components/store/WarehouseHandling";
import CustomersList from "@/components/customers/CustomersList";
import ProductCU from "@/components/productInfo/ProductCU";
import GoodsPrice from "@/components/products/GoodsPrice";
import ProductPriceTraceList from "@/components/products/ProductPriceTraceList.vue";
import SaleYearlyDashboard from "@/components/dashboard/SaleYearlyDashboard.vue";
import {items} from "fusioncharts";
import ProductDetail from "@/components/productInfo/ProductDetail.vue";

export default {
  name: "ProductInfoSearchResult",
  computed: {
    items() {
      return items
    }
  },
  components: {
    ProductDetail,
    SaleYearlyDashboard,
    ProductPriceTraceList,
    GoodsPrice,
    ProductCU,
    CustomersList,
    WarehouseHandling,
    ReserveExiList, ProductDependencyManage, ChangeState, GoodsStore, GoodsCartex
  },
  props: {
    isSelectionForm: {
      type: Boolean,
      default: false
    },
    byPassInsertDialog: {
      type: Boolean,
      default: false
    },
    storeId: {
      type: Number,
      default: -1
    },
    buyList: {
      type: Boolean,
      default: false
    },
    titleSelectGoodDialog: {
      type: String,
      default: 'تعداد انتقالی'
    },
    descriptionSelectGoodDialog: {
      type: String,
      default: 'تعداد انتقالی را وارد نمایید:'
    },
    viewOnly: {
      type: Boolean,
      default: false
    },
    showGroups: {
      type: Boolean,
      default: false
    },
    isExistsLocalSearch: {
      type: Boolean,
      default: false
    },
    buyOrderTrace: {
      type: Boolean,
      default: false
    },
    preBuyOrderRequest: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      qrReaderDialog: false,
      inputProductAmount: 0,
      addProductDialog: false,
      expendedProductGroups: false,
      productGoodsDashboard: false,
      productPriceTrace: false,
      localSearchKey: undefined,
      productWithDelayInSale: 'false',
      changeGoodsPriceDialog: false,
      editProductDialog: false,
      insertProductDialog: false,
      customerList: [],
      customerDialog: false,
      customerListDialogTitle: '',
      warehouseDialog: false,
      filterBuyDayPrice: 'false',
      showReserveDialog: false,
      goodsDependencyDialog: false,
      goodsStateDialog: false,
      goodsEditDialog: false,
      filter: 'false',
      showCartex: false,
      productList: [],
      productListOptions: [],
      selectedProduct: '',
      selectedProductDetails: null,
      showProductDetails: false,
      goodsDependencyViewOnly: false,
      pagination: {
        rowsPerPage: 10
      },
      columns: [
        {
          name: 'title',
          label: 'عنوان کالا',
          field: 'title',
          sortable: true,
          align: 'left',
          style: 'text-align:right',
        },
        {
          name: 'Price',
          label: 'قیمت',
          field: 'Price',
          sortable: true,
          align: 'center',
          style: 'text-align:center',
        },
        {name: 'actions', label: '', field: '', align: 'center'}
      ],
      order_columns: [
        {
          name: 'title',
          label: 'عنوان کالا',
          field: 'title',
          sortable: true,
          align: 'left',
          style: 'text-align:right',
        },
        {
          name: 'amount',
          label: 'تعداد/مقدار',
          field: 'amount',
          sortable: true,
          align: 'center',
          style: 'text-align:center',
        },
        {name: 'actions', label: '', field: '', align: 'center'}
      ]
    }
  },
  methods: {
    ...mapActions({
      getCustomerList: 'Products/getGoodsCustomerRelation',
      getLastGoodsBuy: 'Products/getLastGoodsBuy'
    }),
    goodsPriceUpdated(args) {
      const founded = this.productList.findIndex(item => item.Goods_ID === args.Goods_ID)
      this.productList.splice(founded, 1, args)
      const foundedOptions = this.productListOptions.findIndex(item => item.Goods_ID === args.Goods_ID)
      this.productListOptions.splice(foundedOptions, 1, args)
    },
    productInserted() {
      this.insertProductDialog = false
    },
    onDialogReset() {
      this.inputProductAmount = 0
    },
    onDialogSubmit() {
      this.selectedProduct.selectedCount = this.inputProductAmount
      this.selectedProduct.acceptedCount = 0
      this.selectedProduct.isDone = false
      this.$emit('select-goods', this.selectedProduct)
      this.selectedProduct = undefined
      this.addProductDialog = false
      this.inputProductAmount = 0
    },
    showPriceTrace(rowInfo) {
      this.selectedProduct = rowInfo
      this.productPriceTrace = true
    },
    showGoodsDashBoard(rowInfo) {
      this.selectedProduct = rowInfo
      this.productGoodsDashboard = true
    },
    searchByGroupName(groupName) {
      if (groupName === undefined) {
        this.productList = []
      } else if (groupName === 'total') {
        this.productList = this.productListOptions
      } else {
        this.productList = this.productListOptions.filter(item => item.Group_Name === groupName)
      }
    },
    productUpdated(args) {
      const founded = this.productList.findIndex(item => item.Goods_ID === args.Goods_ID)
      this.productList.splice(founded, 1, args)
      const foundedOptions = this.productListOptions.findIndex(item => item.Goods_ID === args.Goods_ID)
      this.productListOptions.splice(foundedOptions, 1, args)
      this.editProductDialog = false
    },
    updatePrice() {
      this.changeGoodsPriceDialog = false
    },
    showChangePriceDialog(product) {
      this.selectedProduct = product
      this.changeGoodsPriceDialog = true
    },
    showEditProductDialog(product) {
      this.selectedProduct = product
      this.editProductDialog = true
    },
    showInsertProductDialog() {
      this.insertProductDialog = true;
    },
    IsJson(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    },
    selectAllProducts() {
      this.productList.forEach(rec => {
        rec.selectedCount = 1
        this.$emit('select-goods', rec)
      })
    },
    showDependency(row, viewOnly) {
      this.selectedProduct = row
      this.goodsDependencyViewOnly = viewOnly
      this.isSelectionForm = viewOnly
      this.goodsDependencyDialog = true
    },
    changedGoodsState() {
      this.goodsStateDialog = false
    },
    showGoodsStateDialog(row) {
      this.selectedProduct = row
      this.goodsStateDialog = true
    },
    selectGood(row) {
      this.selectedProduct = row
      if (this.byPassInsertDialog === true) {
        this.$emit('select-goods', row)
      } else {
        this.addProductDialog = true
      }
    },
    showGoodsEditDialog(row) {
      this.selectedProduct = row;
      this.goodsEditDialog = true;
    },
    showWarehouseHandling(row) {
      this.selectedProduct = row;
      this.warehouseDialog = true;
    },
    showCatexDialog(row) {
      this.selectedProductDetails = row
      this.showCartex = true;
    },
    showProductDetailsDialog(row) {
      this.selectedProductDetails = row;
      this.showProductDetails = true
    },
    showExistsProduct(data) {
      let result = data;
      if (result.length > 0) {
        if (this.filter === 'true') {
          result = data.filter(row => row.GStor1 + row.GStor2 + row.GStor3 + row.GStor4 + row.GStor6 > 0);
        }
        if (this.filterBuyDayPrice === 'true') {
          result = data.filter(row => row.BuyDay_Date && Math.abs(this.getDateTimeDiffAsDay(this.ToGregorianDateTime(row.BuyDay_Date), this.getTodayDateTime())) > 90);
        }
        if (this.productWithDelayInSale === 'true') {
          result = data.filter(row => row.MustBeSale);
        }
      }
      return result;
    },
    showReserveList(data) {
      this.selectedProduct = data
      this.showReserveDialog = true
    },
    showCustomerNoWorking(row) {
      this.selectedGroup = row;
      this.customerListDialogTitle = `لیست طرف معامله که کالای ${row.Goods_Name} را تاکنون نخریده اند `
      this.getCustomerList({
        goodsId: row.Goods_ID,
        flag: 0
      }).then((res) => {
        this.customerList = res.filter(item => item.CsSpe_ID === 2)
        this.customerDialog = true
      })
    },
    showCustomerWorking(row) {
      this.customerListDialogTitle = `لیست طرف معامله که کالای ${row.Goods_Name} را تاکنون خریده اند `
      this.getCustomerList({
        goodsId: row.Goods_ID,
        flag: 1
      }).then((res) => {
        this.customerList = res.filter(item => item.CsSpe_ID === 2)
        this.customerDialog = true
      })
    },
  },
  watch: {
    localSearchKey: function (value) {
      if (value === '') {
        this.productList = this.productListOptions
      } else {
        this.productList = this.productListOptions.filter(v => v.Goods_Name.indexOf(value) > -1)
      }
    }
  },
  mounted() {
    EventBus.$on('invoke-productinfo-search-result-event', payload => {
      if (this.storeId === -1) {
        this.productListOptions = payload
        if (!this.viewOnly) {
          this.productList = payload;
        }
      } else {
        this.productListOptions = payload.filter(item => item[`GStor${this.storeId}`] > 0);
        this.productList = this.productListOptions;
      }
    });
  },
  created() {
    if (this.buyOrderTrace) {
      this.getLastGoodsBuy().then((res) => {
        this.productListOptions = res
      })
    }
  }
}
</script>

<style scoped>
.my-class > td:before {
  background: rgba(0, 0, 0, 0) !important;
}

.blink {
  animation: blink-animation 1s steps(5, start) infinite;
  -webkit-animation: blink-animation 1s steps(5, start) infinite;
}

@keyframes blink-animation {
  to {
    visibility: hidden;
  }
}

@-webkit-keyframes blink-animation {
  to {
    visibility: hidden;
  }
}
</style>

<style lang="sass">
.my-sticky-header-table
  height: 50vh

  .q-table__top,
  .q-table__bottom,
  thead tr:first-child th
    background-color: #455a64
    color: white

  thead tr th
    position: sticky
    z-index: 1

  thead tr:first-child th
    top: 0


  &.q-table--loading thead tr:last-child th
    top: 48px

  tbody
    scroll-margin-top: 48px
</style>
